/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/9/22, 11:10 AM
 *
 */

import { useQuery } from 'react-query';
import { useDispatch } from 'react-redux';

import { addRole, addUser } from 'features/auth';

import { getUserProfile } from '../requests/auth.request';

export const useProfile = ({ enabled = false }: { enabled?: boolean }) => {
  const dispatch = useDispatch();

  return useQuery(['profile'], getUserProfile, {
    onSuccess: (data) => {
      dispatch(addRole(data.role.slug));
      dispatch(addUser(data));
    },
    enabled,
  });
};
